<template>
  <v-layout fill-height column>
    <div class="progress-steps">
      <EmotionProgress :current="3"/>
    </div>
    <div class="question min-height" v-html="ques[0]"></div>
    <div class="answer">
      <div class="emotion-text pb-5">
            <span v-for="item in emotionStrArr.length" :key="item"
                  :style="{'color':emotionStrArr[item-1].color}">
                {{ emotionStrArr[item - 1].cdNm }}
            </span>
      </div>
      <div>
        <Textarea v-if="cmplt"
                  :value="textarea[0]"
                  :height="140"
                  :counter="500"
                  :placeholder="replyArr[0]"
                  @input="textareaVaule1"
                  readonly
        />
        <Textarea v-else
                  :value="textarea[0]"
                  :height="140"
                  :counter="500"
                  :placeholder="replyArr[0]"
                  @input="textareaVaule1"
        />
      </div>
      <!-- 추가버튼 눌렸을 경우 -->
      <div v-if="step >= 2">
        <Textarea v-if="cmplt"
                  :value="textarea[1]"
                  :height="140"
                  :counter="500"
                  :placeholder="replyArr[1]"
                  @input="textareaVaule2"
                  readonly
        />
        <Textarea v-else
                  :value="textarea[1]"
                  :height="140"
                  :counter="500"
                  :placeholder="replyArr[1]"
                  @input="textareaVaule2"
        />
      </div>
      <!-- 추가버튼 눌렸을 경우 -->
      <div v-if="step >= 3">
        <Textarea v-if="cmplt"
                  :value="textarea[2]"
                  :height="140"
                  :counter="500"
                  :placeholder="replyArr[2]"
                  @input="textareaVaule3"
                  readonly
        />
        <Textarea v-else
                  :value="textarea[2]"
                  :height="140"
                  :counter="500"
                  :placeholder="replyArr[2]"
                  @input="textareaVaule3"
        />
      </div>
      <!-- <div class="text-center">
          <v-btn depressed plain class="btn-add" @click="btnAdd">+ 추가 작성하기</v-btn>
      </div> -->
      <div v-if="!(step === 3) && !cmplt" class="text-center">
        <v-btn depressed plain class="btn-add"
               @click="btnAdd">+ 추가 작성하기
        </v-btn>
      </div>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import Textarea from "@/components/forms/Textarea"
import EmotionProgress from "@/components/progress/EmotionProgress"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "emotionSelectParam"],
  data: () => ({
    step: 1,
    disabledNext: true,
    textarea: ['', '', ''],
    free: 'N',
    cmplt: false,
    ques: [],
    //답변객체
    replyArr: [],
    replyObjArr: [],
    // 유저 답변 객체
    userReplyNo: [0, 0, 0],
    userReply: [],
    emotionStrArr: '',
  }),
  components: {
    EmotionProgress,
    Textarea,
    FooterBtnsNext,
  },
  mounted() {
    this.getUnitDetailUse()
  },
  created() {
    this.emotionStrArr = this.emotionSelectParam
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              this.ques[i] = quesEl.ques
              // this.ques.push(quesEl.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                this.textarea[i + j] = userReplyEl.reply
                this.step = j + 1
              });

              if (this.textarea[0] != '') this.textareaVaule1(this.textarea[0])
              if (this.textarea[1] != '') this.textareaVaule2(this.textarea[1])
              if (this.textarea[2] != '') this.textareaVaule3(this.textarea[2])

            });

          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        for (let i = 0; i < this.step; i++) {

          let replyObj = this.replyObjArr[i]
          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: this.userReplyNo[i],
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: this.textarea[i],
            // score: score/10,
            freeYn: this.free
          }
        }
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    textareaVaule1(value) {
      this.textarea[0] = value;
      if (this.textarea[0] == "" || this.textarea[0].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    textareaVaule2(value) {
      this.textarea[1] = value;
      if (this.textarea[0] == "" || this.textarea[0].length > 500 || this.textarea[1] == "" || this.textarea[1].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    textareaVaule3(value) {
      this.textarea[2] = value;
      if (this.textarea[0] == "" || this.textarea[0].length > 500 || this.textarea[1] == "" || this.textarea[1].length > 500
        || this.textarea[2] == "" || this.textarea[2].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    btnAdd() {
      this.step = this.step + 1;
      if (this.step == 2) this.textareaVaule2(this.textarea[1])
      if (this.step == 3) this.textareaVaule3(this.textarea[2])
    },
  }
}
</script>
